
import { mapState, mapGetters, mapMutations } from 'vuex';
import {
  FLING_VELOCITY_THRESHOLD,
  FLING_VELOCITY_WINDOW_MS
} from '@/constants/GESTURE';
import { REVIEW_DETAIL_DIALOG_HEIGHT } from '@/constants/SHORTS_POPUP';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.ReviewDetailDialog',
  name: 'ReviewDetailDialog',
  props: {
    reviewId: {
      type: Number,
      required: true
    },
    isProductReviewsShortsPopup: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      dragStartY: null,
      dragCurrentY: null,
      dragStartHeight: null,
      dialogHeight: REVIEW_DETAIL_DIALOG_HEIGHT,
      isDragging: false,
      lastMoveTime: null,
      lastMoveY: null
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('session', ['isLoggedIn']),
    ...mapGetters('review', ['reviews']),
    currentReview() {
      return this.reviews.find(r => r.id === this.reviewId);
    },
    showLikeSection() {
      return (
        this.isLoggedIn &&
        (this.reviewSettings.use_likes_count ||
          this.reviewSettings.use_comments)
      );
    },
    dialogStyle() {
      return {
        '--dialog-height': `${this.dialogHeight}px`
      };
    }
  },
  mounted() {
    this.SET_BOTTOM_SHEET_HEIGHT(this.dialogHeight);
  },
  beforeDestroy() {
    this.SET_BOTTOM_SHEET_HEIGHT(null);
  },
  methods: {
    ...mapMutations('bottomSheet', ['SET_BOTTOM_SHEET_HEIGHT']),
    onTouchStart(event) {
      if (!event.touches) return;

      this.dragStartY = event.touches[0].clientY;
      this.dragCurrentY = event.touches[0].clientY;
      this.dragStartHeight = this.dialogHeight;
      this.isDragging = true;
    },
    onTouchMove(event) {
      if (!event.touches || this.dragStartY === null) return;

      this.lastMoveY = this.dragCurrentY;
      this.lastMoveTime = Date.now();
      this.dragCurrentY = event.touches[0].clientY;

      const dragOffset = this.dragCurrentY - this.dragStartY;
      const newHeight = this.dragStartHeight - dragOffset;
      this.dialogHeight = Math.max(0, Math.min(newHeight, window.innerHeight));
      this.SET_BOTTOM_SHEET_HEIGHT(this.dialogHeight);
    },
    onTouchEnd() {
      this.isDragging = false;

      const velocity = this.getDragVelocity();

      if (velocity > FLING_VELOCITY_THRESHOLD) {
        this.$emit('close');
      } else if (velocity < -FLING_VELOCITY_THRESHOLD) {
        this.dialogHeight = window.innerHeight;
        this.SET_BOTTOM_SHEET_HEIGHT(this.dialogHeight);
      } else if (this.dialogHeight < REVIEW_DETAIL_DIALOG_HEIGHT / 2) {
        this.$emit('close');
      }

      this.resetDragState();
    },
    getDragVelocity() {
      if (
        this.lastMoveTime === null ||
        this.lastMoveY === null ||
        this.dragCurrentY === null
      )
        return 0;

      const timeDelta = Date.now() - this.lastMoveTime;
      if (timeDelta > FLING_VELOCITY_WINDOW_MS) return 0;

      const distanceDelta = this.dragCurrentY - this.lastMoveY;
      return distanceDelta / Math.max(1, timeDelta);
    },
    resetDragState() {
      this.dragStartY = null;
      this.dragCurrentY = null;
      this.dragStartHeight = null;
      this.isDragging = false;
      this.lastMoveTime = null;
      this.lastMoveY = null;
    }
  }
};
